// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cta-section {
    background: linear-gradient(to right, #2563eb, #4f46e5);
    padding: 6rem 1rem;
    text-align: center;
    color: white;
  }
  
  .cta-container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .cta-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }
  
  .cta-description {
    font-size: 1.25rem;
    max-width: 600px;
    margin: 0 auto 2.5rem;
    color: #dbeafe;
  }
  
  .cta-button {
    display: inline-block;
    background: linear-gradient(to right, #f59e0b, #f97316);
    color: #1e293b;
    font-weight: 600;
    font-size: 1.1rem;
    padding: 1.1rem 3rem;
    border-radius: 50px;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .cta-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
    background: linear-gradient(to right, #fbbf24, #fb923c);
  }`, "",{"version":3,"sources":["webpack://./src/components/CTASection.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;IAC3B,+CAA+C;IAC/C,uDAAuD;EACzD","sourcesContent":[".cta-section {\n    background: linear-gradient(to right, #2563eb, #4f46e5);\n    padding: 6rem 1rem;\n    text-align: center;\n    color: white;\n  }\n  \n  .cta-container {\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  .cta-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 1.5rem;\n  }\n  \n  .cta-description {\n    font-size: 1.25rem;\n    max-width: 600px;\n    margin: 0 auto 2.5rem;\n    color: #dbeafe;\n  }\n  \n  .cta-button {\n    display: inline-block;\n    background: linear-gradient(to right, #f59e0b, #f97316);\n    color: #1e293b;\n    font-weight: 600;\n    font-size: 1.1rem;\n    padding: 1.1rem 3rem;\n    border-radius: 50px;\n    text-decoration: none;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .cta-button:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);\n    background: linear-gradient(to right, #fbbf24, #fb923c);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
